<script>
import {examAccuracy} from '../../../api/grade'
import {userAvatar} from '../data'

export default {
  name: 'ExamSituation',
  props: {
    classId: {
      type: String | Number,
      required: true
    },
    postbarId: {
      type: String | Number,
      required: true
    },
  },
  data() {
    return {
      dataSource: [],
      postState: {
        pageNum: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
    }
  },
  computed: {
    getAvator() {
      return (item) => {
        if (item.userInfo && item.userInfo.headPicUrl) {
          return item.userInfo.headPicUrl
        }
        return userAvatar[item.roleType]
      }
    }
  },
  methods: {
    async loadData() {
      const params = {
        classId: this.classId,
        postbarId: this.postbarId,
        pageNum: this.postState.pageNum,
        pageSize: this.postState.pageSize
      }
      try {
        const res = await examAccuracy(params)
        if (res.code === 0) {
          this.dataSource = this.dataSource.concat(res.data.list)
          this.postState.finished = res.data.list.length < this.postState.pageSize
          this.postState.pageNum++
        }
      } catch (e) {
        this.$toast(e)
        console.log(e)
      } finally {
        this.postState.loading = false
      }
    }
  }
}
</script>

<template>
  <div class="exam-situation">
    <div class="situation-title">
      <img src="@/assets/images/exam-situation/situation-title-icon.png" alt="">
      <span>学员考试情况</span>
    </div>
    <van-list v-model="postState.loading" :finished="postState && postState.finished" :finished-text="postState.finishText"
              @load="loadData">
      <div class="situation-list" v-for="(item, index) in dataSource" :key="index">
        <div class="situation-list-item">
          <div class="situation-list-item-left">
            <img :src="getAvator(item)" alt="">
          </div>
          <div class="situation-list-item-right">
            <div class="situation-list-item-right-top">
              <div class="situation-list-item-right-top-left">
                {{ item.userInfo ? item.userInfo.realName : '' }}
              </div>
              <div class="situation-list-item-right-top-right">
                <span :class="item.isExam == 1 ? 'isExam':''">{{
                    item.isExam == 1 ? '已参与考试' : '未参与考试'
                  }}: {{ item && item.accuracyStr }}</span>
              </div>
            </div>
            <div class="situation-list-item-bottom">
              {{ item.userInfo ? item.userInfo.hospitalName : '' }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<style scoped lang="less">
.exam-situation {
  width: 100%;
  display: flex;
  flex-direction: column;

  .situation-title {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #E8E8E8;

    img {
      width: 16px;
    }

    span {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #EB1700;
      margin-left: 6px;
    }
  }

  .situation-list {
    .situation-list-item {
      width: 100%;
      height: 62px;
      background: #F9F9F9;
      border-radius: 4px;
      display: flex;
      margin-top: 10px;
      padding: 10px;
      box-sizing: border-box;

      .situation-list-item-left {
        img {
          width: 42px;
          border-radius: 50%;
        }
      }

      .situation-list-item-right {
        margin-left: 6px;
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 0;

        .situation-list-item-right-top {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          .situation-list-item-right-top-left {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            flex: 1;
          }

          .situation-list-item-right-top-right {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #7A8494;

            & > span.isExam {
              color: #EB1700;
            }
          }
        }

        .situation-list-item-bottom {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #7A8494;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/ExamSituation.vue